import { StudioLogger } from '@studio/logger';

const LOG = new StudioLogger('dailyAudioControl');

/**
 * Interface representing a Daily call instance with audio control methods
 */
/* eslint-disable no-unused-vars */
export interface DailyCallInstance {
  setLocalAudio(isMuted: boolean): Promise<any>;
}

/**
 * Toggles audio for a Daily attendee by muting/unmuting the local audio
 * @param dailyCall - The Daily call instance to control audio for
 * @param isMuted - Whether to mute (true) or unmute (false) the audio
 * @returns {Promise<void>}
 */
export const toggleDailyAudio = async (dailyCall: DailyCallInstance, isMuted: boolean): Promise<void> => {
  try {
    await dailyCall.setLocalAudio(!isMuted);
    LOG.info(`Daily Local audio ${isMuted ? 'muted' : 'unmuted'}`);
  } catch (error) {
    LOG.error(`Failed to set Daily audio muted: ${isMuted}`, error);
    throw error;
  }
};
